import { useNavigate } from "react-router-dom";

export function BackButtonFlex({ customPath }: { customPath?: string }) {
  const navigate = useNavigate();
  return (
    <div
      className="columns"
      style={{ alignItems: "flex-end", marginBottom: ".05rem" }}
    >
      <div className="is-fullwidth column">
        <button
          onClick={() => (!customPath ? navigate(-1) : navigate(customPath))}
          className="button is-medium is-fullwidth button-cartel-light"
        >
          Retour
        </button>
      </div>
    </div>
  );
}
